import React, { useState } from "react";
import InView from "react-intersection-observer";
import CSIntroImage1 from "../../images/Human-Graphic.png";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

export default function SalesmateCsIntro() {
  const [isVsible, setisVsible] = useState({ one: false, two: false });
  return (
    <div className="cs-intro-section section-gap sm-cs-intro-section" >
      <div className="container-small" >
        <InView as="div" className="intro-inner" onChange={(inView) => setisVsible(prev => { return { ...prev, one: inView }; })}>
          <p className="theme-color-title blue-color">{isVsible.one ? <HeaderAnim header="THE CHALLENGE" /> : ""}</p>
          <h2 className="h3">Solving the sales productivity puzzle</h2>
          <p>Sales is the most important function of any business. Sales productivity is an age-old problem that CRMs were designed to solve, but it is still a puzzle. The top CRMs are focused on “managing” sales, not “growing” it, and the primary users, sales reps, hated using it.  While they are good record-keeping systems, they are clunky, manual, and outdated. The reps lose about 40% of their time updating CRM and juggle 4 to 7 other tools for emails, calls, meetings, etc. </p>
          <p>Lack of automation, focus, and context are big blockers for the frontline sales teams to grow sales revenue and customer relationships. The $100+ billion industry needs a more promising platform.</p>
        </InView>

        <div className="cs-intro-image">
          <LazyLoad>
            <img src={CSIntroImage1} className="intro-large-image" title="crm software for sales productivity" alt="sales productivity" />
          </LazyLoad>
        </div>

        <InView as="div" className="intro-inner" onChange={(inView) => setisVsible(prev => { return { ...prev, two: inView }; })}>
          <p className="theme-color-title blue-color">{isVsible.two ? <HeaderAnim header="THE SOLUTION" /> : ""}</p>
          <h2 className="h3">Launching the world’s first sales operating system</h2>
          <p>Salesmate team wanted us to build the sales operating system that enables every business to organize, automate, and optimize their sales and customer journey their way. It needs to power every frontline sales team to engage prospects, win more deals, automate busywork, and improve their performance.</p>
        </InView>

      </div>
    </div>
  );
}